import { render, staticRenderFns } from "./ValueChainAttributes.vue?vue&type=template&id=ad043366&scoped=true&"
import script from "./ValueChainAttributes.vue?vue&type=script&lang=js&"
export * from "./ValueChainAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ValueChainAttributes.vue?vue&type=style&index=0&id=ad043366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad043366",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
